import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ContextChips = ({ filters, dimensions, onFilterRemove, onClearAll }) => {
  const getDimensionLabel = (dimId) => {
    const dim = dimensions.find(d => d.id.toString() === dimId.toString());
    return dim?.label || dimId;
  };

  const getValueLabel = (dimId, valueCode) => {
    const dim = dimensions.find(d => d.id.toString() === dimId.toString());
    if (!dim || !dim.values_json) return valueCode;
    const value = dim.values_json.find(v => v.code === valueCode);
    return value?.label || valueCode;
  };

  if (Object.keys(filters).length === 0) return null;

  return (
    <div className="context-chips">
      {Object.entries(filters).map(([dimId, valueCode]) => (
        <div key={dimId} className="context-chip">
          <span className="chip-label">
            {getDimensionLabel(dimId)}: {getValueLabel(dimId, valueCode)}
          </span>
          <button
            className="chip-remove"
            onClick={() => onFilterRemove(dimId, null)}
            title="Retirer ce filtre"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      ))}
      <button className="context-chip-clear" onClick={onClearAll}>
        Tout effacer
      </button>
    </div>
  );
};

export default ContextChips;

